'use strict';
import React from 'react';
import { Link } from 'react-router-dom';
import employeeAction from '../../actions/employeeAction';

class EmpCard extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }
    static defaultProps = {
        statusTxt: ["Employed", "Resigned", "Dismissed", "Terminated"]
    }
    handleClick(e) {
        employeeAction.staffId(this.props.staff.staffId);
        employeeAction.displayDetail(true);
    }

    render() {
        return (

            <div className="atd-card" onClick={this.handleClick}>
                <div className="atd-img-wp">
                    <img className="atd-img" src={this.props.staff.userImage} />
                </div>
                <div className="atd-nm">
                    {this.props.staff.userName}
                    <b>{this.props.staff.status != 0 ? " - " + this.props.statusTxt[this.props.staff.status] : ""}</b>
                </div>
            </div>

        );
    }
}
export default EmpCard;


// WEBPACK FOOTER //
// ./app/components/employeeComponents/empCard.js